import { StrictMode, startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import i18nReady from './i18n'
import { registerSW } from 'virtual:pwa-register'
import { domainHandoffUrl } from './apiClient'

const handoffUrl = domainHandoffUrl(
  window.location.hostname,
  window.location.pathname + window.location.search
)
if (handoffUrl) window.location.replace(handoffUrl)

// Fix for in-app browsers (Google Search App, Instagram, etc.) that inject/remove
// DOM nodes, causing React's removeChild/insertBefore to crash.
// See: https://github.com/facebook/react/issues/17256
if (typeof Node !== 'undefined') {
  const origRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      console.warn('removeChild: node not a child', child)
      return child
    }
    return origRemoveChild.call(this, child) as T
  }

  const origInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(newNode: T, refNode: Node | null): T {
    if (refNode && refNode.parentNode !== this) {
      console.warn('insertBefore: ref node not a child', refNode)
      return newNode
    }
    return origInsertBefore.call(this, newNode, refNode) as T
  }
}

if (!handoffUrl) {
  const updateSW: (reloadPage?: boolean) => Promise<void> = registerSW({
    immediate: true,
    onNeedRefresh() {
      updateSW(true)
    },
  })

  if ('serviceWorker' in navigator) {
    let refreshing = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return
      refreshing = true
      window.location.reload()
    })
  }

  i18nReady.then(() => {
    startTransition(() => {
      hydrateRoot(
        document,
        <StrictMode>
          <HydratedRouter />
        </StrictMode>
      )
    })
  })
}
